import { Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import { formatDate } from 'dashboard/lib/utils/formatters';
import Attribute, { AttributeGrid } from 'design-system/components/Attribute';

export const PoliticallyExposedPersonInputDetails = ({
  input,
}: {
  input: {
    'name-first'?: string;
    'name-last'?: string;
    birthdate?: string;
    'country-code'?: string;
  };
}) => {
  const {
    'name-first': nameFirst,
    'name-last': nameLast,
    birthdate: birthdate,
    'country-code': countryCode,
  } = input;

  return (
    <StyledAttributeGrid>
      {nameFirst && (
        <Attribute label='First Name' value={nameFirst} placeholder='N/A' horizontal={true} />
      )}
      {nameLast && (
        <Attribute label='Last Name' value={nameLast} placeholder='N/A' horizontal={true} />
      )}
      {birthdate && (
        <Attribute
          label='Birthdate'
          value={formatDate(birthdate)}
          placeholder='N/A'
          horizontal={true}
        />
      )}
      {countryCode && (
        <Attribute
          label='Country'
          value={countryCode}
          placeholder='N/A'
          horizontal={true}
          helpText='Country of Position'
        />
      )}
    </StyledAttributeGrid>
  );
};

const StyledAttributeGrid = styled(AttributeGrid)`
  gap: ${Spacing[2]};

  & dt {
    width: 100px;
  }
`;
